import axios from "axios";

let baseUrl = "/api";

axios.interceptors.request.use(
    config => {
        config.headers['token'] = "pass";
        return config;
    }
);


/**
 * 登录
 * @param params 参数
 * @returns {AxiosPromise}
 */
export const login = (params) => {
    return axios.post(baseUrl + '/user/admin/login', params);
};

/**
 * 注册
 * @param params 参数
 * @returns {AxiosPromise}
 */
export const register = (params) => {
    return axios.post(baseUrl + '/user/add', params);
};

/**
 * 获取天气
 * @param params 参数
 * @returns {AxiosPromise}
 */
export const getWeather = (params) => {
    return axios.get(baseUrl+'/weather/chinaWeather?city='+ params);
};

